import type { ShareButtonProps, SocialShareType } from "@product/scmp-sdk";
import { findFirstNonEmptyString } from "@product/scmp-sdk";
import uniq from "lodash/uniq";
import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import type { contentShareWidgetContent$key } from "~/queries/__generated__/contentShareWidgetContent.graphql";

import { Container, StyledShareButton } from "./styles";

export type Props = {
  onClick?: (type: SocialShareType) => void;
  reference: contentShareWidgetContent$key;
  types: SocialShareType[];
} & Omit<ShareButtonProps, "relativeUrl" | "shortUrl" | "title" | "utm" | "type">;

export const ContentShareWidget: FunctionComponent<Props> = ({
  className,
  onClick,
  reference: reference_,
  types,
  ...props
}) => {
  const content = useFragment(
    graphql`
      fragment contentShareWidgetContent on Content {
        entityId
        urlAlias
        shortUrl
        socialHeadline
        headline
      }
    `,
    reference_,
  );

  return (
    <Container className={className}>
      {uniq(types).map(type => (
        <StyledShareButton
          key={type}
          relativeUrl={content.urlAlias}
          shortUrl={content.shortUrl}
          title={findFirstNonEmptyString(content.socialHeadline, content.headline)}
          type={type}
          utm={{
            campaign: content.entityId,
            medium: "share_widget",
          }}
          onClick={() => onClick?.(type)}
          {...props}
        />
      ))}
    </Container>
  );
};

ContentShareWidget.displayName = "ContentShareWidget";
